export class MessageBus {
  private handlers: Array<HandlerEntry> = [];

  public publish<T>(message: T) {
    this.handlers.forEach(({ messageClass, handler }) => {
      if (message instanceof messageClass) {
        handler(message);
      }
    });
  }

  public subscribe<T>(messageClass: MessageClass<T>, handler: Handler<T>) {
    const handlerEntry = { messageClass, handler };
    this.handlers.push(handlerEntry);
    return () => {
      this.handlers = this.handlers.filter((entry) => entry !== handlerEntry);
    };
  }
}

export type Handler<T> = (message: T) => void;
export type MessageClass<T> = new (...args: any[]) => T;

interface HandlerEntry {
  messageClass: MessageClass<any>;
  handler: Handler<any>;
}
